import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-header flex md:flex-row flex-column justify-content-between" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "mt-0" }
const _hoisted_5 = {
  key: 0,
  class: "header-right flex flex-row gap-2"
}
const _hoisted_6 = { class: "stat-div" }
const _hoisted_7 = { class: "stat-div" }
const _hoisted_8 = { class: "stat-div" }
const _hoisted_9 = { class: "stat-div" }
const _hoisted_10 = { class: "app-inner-container" }
const _hoisted_11 = { class: "details-container" }
const _hoisted_12 = { class: "form-left-content" }
const _hoisted_13 = { class: "details-container" }
const _hoisted_14 = { class: "details-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Indisponibil momentan", -1)

import { Doctor } from '@/interfaces/Doctor';
import { Seller } from '@/interfaces/Seller';
import { Patient } from '@/interfaces/Patient';
import { Consultation } from '@/interfaces/Consultation';
import DoctorService from '@/services/DoctorService';
import PatientsService from '@/services/PatientsService';
import Card from 'primevue/card';

import PatientList from '@/components/PatientList.vue';
import ConsultationList from '@/components/ConsultationList.vue';
import PatientConsultationList from '@/components/PatientConsultationList.vue';

import DoctorEntity from '@/components/DoctorEntity.vue';

import DoctorEntityService from '@/services/DoctorEntityService';
import DoctorForm from '@/components/DoctorForm.vue';
import EntityForm from '@/components/EntityForm.vue';
import DoctorConfig from '@/components/forms/doctor/DoctorConfig.vue';
import DoctorPayoutConfig from '@/components/forms/doctor/DoctorPayoutConfig.vue';
import DoctorFiles from '@/components/forms/doctor/DoctorFiles.vue';
import { onMounted, ref, Ref, inject, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import { DoctorEntityServiceCtx } from '@/api';
import ConsultationService from '@/services/ConsultationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorDetailsView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const confirm = useConfirm();
const toast = useToast();
const doctorId = route.params.id as string;
const refId = route.query.refId as string | undefined;

const doctorEntityService: DoctorEntityService | undefined = inject(
  DoctorEntityServiceCtx
);

const doctor: Ref<Doctor | null> = ref(null as Doctor | null);
const entity: Ref<typeof DoctorEntity | null> = ref(
  null as typeof DoctorEntity | null
);
const config: Ref<typeof DoctorEntity | null> = ref(
  null as typeof DoctorEntity | null
);
const seller: Ref<Seller | null> = ref(null as Seller | null);
const patients: Ref<Patient[]> = ref([] as Patient[]);
const consultations: Ref<Consultation[]> = ref([] as Consultation[]);

const isValidForm = ref(true);
const isValidDoctorForm = ref(false);
const isValidEntityForm = ref(true);

const activeTab = ref(1);

const safeDisplay = (value: string): string => value || '';

const selectedPatient = computed(() =>
  refId ? patients.value.find(p => p.id === refId) ?? null : null
);

const doctorFullName = computed(() =>
  [safeDisplay(doctor.value?.title!), safeDisplay(doctor.value?.firstName!), safeDisplay(doctor.value?.lastName!)]
    .filter(Boolean).join(' ')
);


const onTabChange = (event: { index: number }) => {
  activeTab.value = event.index;
  if (event.index === 0) {
    router.replace({ path: '/doctors' });
  }
};


const sendDoctorInvitationConfirmation = () => {
  confirm.require({
    message: 'Sunteți sigur că doriți să trimiteți SMS medicului?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: () => {
      try {
        DoctorService.sendDoctorInvitation(doctorId);
        toast.add({
          severity: 'success',
          summary: 'Succes',
          detail: 'Invitație trimisă cu succes',
          life: 3000
        });
      } catch {
        toast.add({
          severity: 'error',
          summary: 'Eroare',
          detail: 'Nu s-a putut trimite invitația',
          life: 3000
        });
      }
    }
  });
};

const onFormValidationChangeState = (newValue) => {
  isValidDoctorForm.value = newValue;
  applyValidation();
};

const onEntityFormValidationChangeState = (newValue) => {
  isValidEntityForm.value = newValue;
  applyValidation();
};

const applyValidation = () => {
  isValidForm.value = isValidDoctorForm.value && isValidEntityForm.value;
};

const blockDoctorConfirmation = () => {
  confirm.require({
    message: 'Sunteți sigur că doriți să deblocați contul medicului?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: () => {
      blockDoctor(doctor.value!);
    }
  });
};

const unblockDoctorConfirmation = () => {
  confirm.require({
    message: 'Sunteți sigur că doriți să deblocați contul medicului?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: () => {
      unblockDoctor(doctor.value!);
    }
  });
};

const deleteDoctorConfirmation = () => {
  confirm.require({
    message:
      'Atenție! Această acțiune este ireversibilă! Sunteți sigur că doriți să ștergeți contul medicului?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: () => {
      deleteDoctor(doctor.value!);
    }
  });
};

const updateDoctorConfirmation = () => {
  confirm.require({
    message: 'Sunteți sigur că doriți să actualizați datele doctorului?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: () => {
      updateDoctor(doctor.value!);
    }
  });
};

const blockDoctor = async (doctor: Doctor) => {
  try {
    const suspended: boolean = await DoctorService.suspendDoctor(doctor.id);
    showSuccess();
    location.reload();
  } catch (err) {
    if (err instanceof Error) {
      showError(err.message);
    } else {
      showError('A apărut o eroare la blocarea utilizatorului.');
    }
  }
};

const unblockDoctor = async (doctor: Doctor) => {
  try {
    const reactivated: boolean = await DoctorService.reactivateDoctor(
      doctor.id
    );
    showSuccess();
    location.reload();
  } catch (err) {
    if (err instanceof Error) {
      showError(err.message);
    } else {
      showError('A apărut o eroare la deblocarea utilizatorului.');
    }
  }
};

const deleteDoctor = async (doctor: Doctor) => {
  try {
    const deleted: boolean = await DoctorService.deleteDoctor(doctor.id);
    showSuccess();
    location.reload();
  } catch (err) {
    if (err instanceof Error) {
      showError(err.message);
    } else {
      showError('A apărut o eroare la stergerea utilizatorului.');
    }
  }
};

const updateDoctor = async (doctor: Doctor) => {
  try {
    const doctorId: string = (await DoctorService.updateDoctor(doctor)).id;
    showSuccess();
    doctor.config && saveDoctorConfig(doctorId, doctor.config);
    doctor.entity && saveDoctorEntity(doctorId, doctor.entity);
    location.reload();
  } catch (err) {
    if (err instanceof Error) {
      showError(err.message);
    } else {
      showError('A apărut o eroare la actualizarea utilizatorului.');
    }
  }
};

// @ts-ignore
const saveDoctorConfig = async (doctorId: string, config: DoctorConfig) => {
  try {
    if (config?.commissionPercent) {
      config.commissionPercent = config.commissionPercent / 100;
    }
    await DoctorService.saveDoctorConfig(doctorId, config);
  } catch {
    showError('A apărut o eroare la actualizarea configurației.');
  }
};

// @ts-ignore
const saveDoctorEntity = async (doctorId: string, entity: DoctorEntity) => {
  try {
    await DoctorService.saveDoctorEntity(doctorId, entity);
  } catch {
    showError('A apărut o eroare la actualizarea entitații fiscale.');
  }
};

const showError = (message: string): void => {
  toast.add({
    severity: 'error',
    summary: 'A apărut o eroare!',
    detail: message,
    life: 3000
  });
};

const showSuccess = (): void => {
  toast.add({
    severity: 'success',
    summary: 'Acțiune realizată cu succes!',
    detail: 'Utilizatorul a fost actualizat cu succes',
    life: 3000
  });
};

onMounted(async () => {
  try {
    const fetchedDoctor = await DoctorService.fetchDoctor(doctorId);
    if (fetchedDoctor) {
      doctor.value = fetchedDoctor;
      if (doctor.value) {
        const fetchedConfig = await DoctorService.fetchDoctorConfig(doctorId);
        if (fetchedConfig) {
          fetchedConfig.commissionPercent =
            fetchedConfig.commissionPercent * 100;
          // @ts-ignore
          config.value = fetchedConfig;
          // @ts-ignore
          doctor.value.config = config.value;
        }
        const fetchedEntity = await doctorEntityService?.fetchDoctorEntity(
          doctor.value.id
        );
        if (fetchedEntity) {
          doctor.value.entity = fetchedEntity;
        }
      }
    }
    const fetchedPatients = await PatientsService.fetchPatientsByDoctorId(doctorId);
    if (fetchedPatients && fetchedPatients["content"] && Array.isArray(fetchedPatients["content"])) {
      patients.value = fetchedPatients["content"];
    } else {
      patients.value = fetchedPatients as Patient[];
    }
    if (doctor.value?.id) {
      seller.value = new Object() as Seller;
    }

    if(refId !== undefined) {
      const fetchedConsultations = await ConsultationService.fetchConsultationsOfDoctorAndPatient(doctorId, refId);
      if(fetchedConsultations && Array.isArray(fetchedConsultations)) {
        consultations.value = fetchedConsultations;
      }
    } else {
      const fetchedConsultations = await ConsultationService.fetchConsultationsOfUser(doctorId);
      if(fetchedConsultations && Array.isArray(fetchedConsultations)) {
        consultations.value = fetchedConsultations;
      }
    }
  } catch (error) {
    seller.value = new Object() as Seller;
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmDialog)),
    _createVNode(_unref(Card), null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(refId) && selectedPatient.value
              ? safeDisplay(selectedPatient.value.firstName) + ' ' + safeDisplay(selectedPatient.value.lastName)
              : doctorFullName.value), 1),
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(refId) && selectedPatient.value ? 'Consultatii ' + doctorFullName.value : 'Detalii generale'), 1)
          ]),
          (doctor.value?.status != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createVNode(_unref(Button), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (updateDoctorConfirmation())),
                    class: "p-button-md text-white",
                    icon: "pi pi-user-edit",
                    disabled: !isValidForm.value
                  }, null, 8, ["disabled"]), [
                    [
                      _directive_tooltip,
                      {
                value: 'Actualizati datele',
                showDelay: 100,
                hideDelay: 300
              },
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode(_unref(Button), {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (sendDoctorInvitationConfirmation())),
                    class: "p-button-md",
                    outlined: "",
                    icon: "pi pi-envelope"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      {
                value: 'Trimiteti invitatie',
                showDelay: 100,
                hideDelay: 300
              },
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (doctor.value?.status == 2)
                    ? _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (unblockDoctorConfirmation())),
                        class: "p-button-md",
                        outlined: "",
                        severity: "success",
                        icon: "pi pi-unlock"
                      }, null, 512)), [
                        [
                          _directive_tooltip,
                          {
                value: 'Deblocati utlizatorul',
                showDelay: 100,
                hideDelay: 300
              },
                          void 0,
                          { left: true }
                        ]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (blockDoctorConfirmation())),
                        class: "p-button-md text-red-500",
                        outlined: "",
                        severity: "warning",
                        icon: "pi pi-ban"
                      }, null, 512)), [
                        [
                          _directive_tooltip,
                          {
                value: 'Blocati utlizatorul',
                showDelay: 100,
                hideDelay: 300
              },
                          void 0,
                          { left: true }
                        ]
                      ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createVNode(_unref(Button), {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteDoctorConfirmation())),
                    class: "p-button-md text-white",
                    severity: "danger",
                    icon: "pi pi-trash"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      {
                value: 'Stergeti utlizatorul',
                showDelay: 100,
                hideDelay: 300
              },
                      void 0,
                      { left: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(TabView), {
            activeIndex: activeTab.value,
            "onUpdate:activeIndex": _cache[9] || (_cache[9] = ($event: any) => ((activeTab).value = $event)),
            onTabChange: onTabChange
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TabPanel), { header: "Medici" }),
              (!_unref(refId))
                ? (_openBlock(), _createBlock(_unref(TabPanel), {
                    key: 0,
                    header: "Detalii"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(DoctorForm, {
                            modelValue: doctor.value!,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((doctor.value!) = $event)),
                            "onUpdate:formValidationChangeState": 
                    onFormValidationChangeState
                  
                          }, null, 8, ["modelValue", "onUpdate:formValidationChangeState"]),
                          _createVNode(EntityForm, {
                            modelValue: doctor.value!,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((doctor.value!) = $event)),
                            "onUpdate:entityFormValidationChangeState": 
                    onEntityFormValidationChangeState
                  
                          }, null, 8, ["modelValue", "onUpdate:entityFormValidationChangeState"]),
                          _createVNode(DoctorFiles, {
                            doctor: doctor.value!
                          }, null, 8, ["doctor"])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(refId))
                ? (_openBlock(), _createBlock(_unref(TabPanel), {
                    key: 1,
                    header: "Configurare"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(DoctorConfig, {
                          modelValue: config.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((config).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(refId))
                ? (_openBlock(), _createBlock(_unref(TabPanel), {
                    key: 2,
                    header: "Decontare"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(DoctorPayoutConfig, {
                          modelValue: config.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((config).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(TabPanel), { header: "Pacienti" }, {
                default: _withCtx(() => [
                  (!_unref(refId))
                    ? (_openBlock(), _createBlock(PatientList, {
                        key: 0,
                        patients: patients.value
                      }, null, 8, ["patients"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(TabPanel), { header: "Consultatii" }, {
                default: _withCtx(() => [
                  (_unref(refId))
                    ? (_openBlock(), _createBlock(PatientConsultationList, {
                        key: 0,
                        consultations: consultations.value,
                        patient: selectedPatient.value
                      }, null, 8, ["consultations", "patient"]))
                    : (_openBlock(), _createBlock(ConsultationList, {
                        key: 1,
                        consultations: consultations.value,
                        mode: "doctor"
                      }, null, 8, ["consultations"]))
                ]),
                _: 1
              }),
              (!_unref(refId))
                ? (_openBlock(), _createBlock(_unref(TabPanel), {
                    key: 3,
                    header: "Rapoarte"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})